import React from 'react';

const googleMapsKey = process.env.REACT_APP_GOOGLE_MAPS_KEY;

const MapSelection = ({ center, points }) => {
    if (!points || points.length === 0) return null;

    // Helper to generate Google Static Map URL with polygon
    // const getStaticMapUrl = (center, points) => {
    //     const path = points.map(p => `${p.lat},${p.lng}`).join('|');
    //     const centerStr = `${center.lat},${center.lng}`;
    //     return `https://maps.googleapis.com/maps/api/staticmap?center=${centerStr}&zoom=20&size=800x500&maptype=satellite&path=color:0x79B41C80|weight:4|${path}&key=${googleMapsKey}`;
    // };

    const getStaticMapUrl = (center, points) => {
        const closedPoints = [...points, points[0]]; // close polygon
        const path = closedPoints.map(p => `${p.lat},${p.lng}`).join('|');
        const centerStr = `${center.lat},${center.lng}`;
        return `https://maps.googleapis.com/maps/api/staticmap?center=${centerStr}&zoom=20&size=800x500&maptype=satellite&path=fillcolor:0x79B41C55|color:0x79B41C80|weight:2|${path}&key=${googleMapsKey}`;
    };    

    return (
        <img
            src={getStaticMapUrl(center, points)}
            alt="Map with polygon"
            style={{ width: '800px', height: '500px' }}
        />
    );
};

export default MapSelection;